(function () {
  var RE = /\[PLACEHOLDER[^\]]*\]/g;
  function mark(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var list = [];
    var n;
    while ((n = walker.nextNode())) {
      RE.lastIndex = 0;
      if (RE.test(n.nodeValue) && !(n.parentNode.closest && n.parentNode.closest('mark.cc-ph'))) list.push(n);
      RE.lastIndex = 0;
    }
    list.forEach(function (t) {
      var frag = document.createDocumentFragment();
      var s = t.nodeValue;
      var last = 0;
      var m;
      RE.lastIndex = 0;
      while ((m = RE.exec(s))) {
        if (m.index > last) frag.appendChild(document.createTextNode(s.slice(last, m.index)));
        var k = document.createElement('mark');
        k.className = 'cc-ph';
        k.textContent = m[0];
        frag.appendChild(k);
        last = m.index + m[0].length;
      }
      if (last < s.length) frag.appendChild(document.createTextNode(s.slice(last)));
      t.parentNode.replaceChild(frag, t);
    });
  }
  function run() {
    document.querySelectorAll('.cc-editable').forEach(mark);
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:block:select', run);
})();
